import ENV from 'tio-employee/config/environment';

export default function awsUrl(path: string) {
  return `https://tuitionio-${ENV.tioEnvironment}-images.s3.amazonaws.com/${path}`;
}
